export default function About() {
  return (
    <section id="about" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-16 items-center">
          <div className="lg:col-span-3 space-y-8">
            <div className="inline-block px-4 py-2 bg-cyan-100 text-cyan-600 text-sm font-semibold rounded-full">
              About ECJL LTD
            </div>

            <h2 className="text-5xl font-bold text-gray-900 leading-tight">
              Protecting Privacy Since Day One
            </h2>

            <div className="space-y-6 text-lg text-gray-600 leading-relaxed max-w-2xl">
              <p>
                ECJL LTD is a Cyprus-based technology company dedicated to developing innovative applications that enhance digital security and user experience. Our mission is to provide cutting-edge solutions that protect your online privacy and give you complete control over your digital life.
              </p>

              <p>
                Based in Nicosia, Cyprus, we combine European data protection standards with advanced technology to deliver world-class VPN services. Our team of security experts and developers work tirelessly to ensure your data remains private and secure at all times.
              </p>

              <p>
                We believe that online privacy is a fundamental right, not a luxury. That's why we've built our VPN solution with military-grade encryption, a strict no-logs policy, and lightning-fast servers across the globe to give you the freedom to browse, stream, and work without boundaries.
              </p>
            </div>
          </div>

          <div className="lg:col-span-2">
            <div className="relative group">
              <div className="absolute -inset-1 bg-gradient-to-r from-cyan-400 to-purple-600 rounded-3xl blur opacity-25 group-hover:opacity-40 transition duration-300"></div>
              <div className="relative bg-white rounded-3xl p-2 shadow-xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/e5e18f85dbd6f665e95368076a29ea9a.jpg"
                  alt="ECJL LTD Office"
                  className="rounded-2xl w-full h-auto object-cover"
                />
                <div className="absolute top-6 right-6 bg-white px-4 py-2 rounded-full shadow-lg flex items-center space-x-2">
                  <i className="ri-map-pin-line text-cyan-500"></i>
                  <span className="text-sm font-semibold text-gray-900">Nicosia, Cyprus</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
